import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/views/loginpage.vue';
import UserPage from '@/views/userpage.vue'; // تأكد من أن هذا هو المكون الخاص بصفحة المستخدمين
import Categoriespage from '@/views/categoriespage.vue';
import Couponmanagement from '@/views/couponmanagement.vue';
import Coursemanagement from '@/views/coursemanagement.vue';
import Newsmanagement from '@/views/newsmanagement.vue';
import Slidermanagement from '@/views/slidermanagement.vue';
import Universitymanagement from '@/views/universitymanagement.vue';
import Managingsystemuserspage from '@/views/managingsystemuserspage.vue';
import Dashbordpage from '@/views/dashbordpage.vue';
import Coursevideos from '@/views/coursevideos.vue';
import Transctionspage from '@/views/transctionspage.vue';
import ResetPasswordPage from '@/views/resetpasswordpage.vue';
import ForgotPasswordPage from '@/views/forgotpasswordpage.vue';
import PurchasedCoursesPage from '@/views/purchasedcoursespage.vue';

const routes = [
  {
    path: '/',
    redirect: '/login', // إعادة توجيه المسار الجذري إلى صفحة تسجيل الدخول
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/DashboardPage',
    name: 'DashboardPage',
    component: Dashbordpage, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/userpage',
    name: 'UserPage',
    component: UserPage, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/managingsystemuserspage',
    name: 'managingsystemuserspage',
    component: Managingsystemuserspage, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/categoryPage',
    name: 'categoryPage',
    component: Categoriespage, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/couponPage',
    name: 'couponPagemanagement',
    component:Couponmanagement, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/coursePage',
    name: 'coursePagemanagement',
    component:Coursemanagement, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/newsPage',
    name: 'newsPagemanagement',
    component:Newsmanagement, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/sliderPage',
    name: 'sliderPagemanagement',
    component:Slidermanagement, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/universityPage',
    name: 'universityPagemanagement',
    component:Universitymanagement, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/CourseVideos',
    name: 'CourseVideos',
    component:Coursevideos, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/transctionspage',
    name: 'transctionspage',
    component:Transctionspage, // تأكد من ربط المكون الصحيح
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordPage,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
  },
  {
    path: '/purchasedcourses',
    name: 'PurchasedCoursesPage',
    component: PurchasedCoursesPage,
  },
  // يمكنك إضافة مسارات أخرى هنا لاحقاً
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
